import React from "react";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import Intents from "./pages/Intents";
import SkillActivations from "./pages/SkillActivations";
import MessageFromLastHour from "./pages/MessageFromLastHour";
import ConversationPath from "./pages/ConversationPath";
import { connect } from "react-redux";
import Utterance from "./pages/Utterance";

const AllComponents = ({ page }) => {
  return (
    <>
      {page === 0 && <Dashboard />}
      {page === 1 && <Customers />}
      {page === 2 && <Intents />}
      {page === 3 && <Utterance />}
      {page === 4 && <SkillActivations />}
      {page === 5 && <ConversationPath />}
      {page === 6 && <MessageFromLastHour />}
    </>
  );
};

const mapStateToProps = (state) => ({
  page: state.pageState.page,
});
export default connect(mapStateToProps)(AllComponents);
